import { PublicService, ObserverService, ListingModalService, ContentService } from '@DavisDigital/davisdigitalfrontend.module';


class AgreementPrivacyController {
	
	private slatwall: any;
	
	// @ngInject
	constructor(
		public publicService	    : PublicService,
		public contentService      : ContentService,
		public listingModalService : ListingModalService,
		private ModalService
	){ }
	
	public launchModal = () => {
		this.ModalService.showModal({
			component: 'agreementPrivacyModal',
			bodyClass: 'angular-modal-service-active',
			bindings: {slatwall: this.slatwall},
		}).then((modal) => {});
	};

	public $onInit = () => {
		if (!this.slatwall.account.acceptedAgreementFlag) {
	    	this.launchModal();
		}
	}
}

class AgreementPrivacy {
	public restrict: string = 'E';
	public scope: {};

	public bindToController: any = {
 		slatwall: '='
	};

	public controller = AgreementPrivacyController;
	public controllerAs = 'agreementPrivacy';

	public templateUrl = __DAVIS_FRONTEND_BASE_PATH__ + '/davisdigital/directives/agreement-privacy.html';

	public static Factory() {
		return () => new this();
	}
}

export { AgreementPrivacy };
